module.exports = __webpack_public_path__ + "static/media/location-maps-letter-b.4d8790e3.png";